export const STATUS_CONFIG = {
  active: {
    label: "Active",
    color: "#22c55e",
    bg: "rgba(34, 197, 94, 0.12)",
    border: "#22c55e",
  },
  transit: {
    label: "In Transit",
    color: "#4682b4",
    bg: "rgba(70, 130, 180, 0.18)",
    border: "#4682b4",
  },
  idle: {
    label: "Idle",
    color: "#71717a",
    bg: "rgba(113, 113, 122, 0.15)",
    border: "#71717a",
  },
  maintenance: {
    label: "Maintenance",
    color: "#eab308",
    bg: "rgba(234, 179, 8, 0.15)",
    border: "#eab308",
  },
  alert: {
    label: "Alert",
    color: "#ef4444",
    bg: "rgba(239, 68, 68, 0.15)",
    border: "#ef4444",
  },
};

export const ASSET_TYPE_CONFIG = {
  truck: { label: "Truck", icon: "Truck" },
  dumpster: { label: "Dumpster", icon: "Package" },
  excavator: { label: "Excavator", icon: "Wrench" },
  loader: { label: "Loader", icon: "Tractor" },
  crane: { label: "Crane", icon: "Crane" },
  bulldozer: { label: "Bulldozer", icon: "Bulldozer" },
};

export const JOB_STATUS_CONFIG = {
  scheduled: { label: "Scheduled", color: "#a1a1aa", bg: "rgba(161, 161, 170, 0.15)" },
  dispatched: { label: "Dispatched", color: "#4682b4", bg: "rgba(70, 130, 180, 0.18)" },
  in_progress: { label: "In Progress", color: "#ff8c00", bg: "rgba(255, 140, 0, 0.15)" },
  completed: { label: "Completed", color: "#22c55e", bg: "rgba(34, 197, 94, 0.12)" },
  cancelled: { label: "Cancelled", color: "#ef4444", bg: "rgba(239, 68, 68, 0.12)" },
};

export const PRIORITY_CONFIG = {
  low: { label: "Low", color: "#71717a" },
  medium: { label: "Medium", color: "#4682b4" },
  high: { label: "High", color: "#ff8c00" },
  urgent: { label: "Urgent", color: "#ef4444" },
};

export const VEHICLE_CLASSES = [
  { value: "class_3", label: "Class 3 (10,001-14,000 lbs)" },
  { value: "class_5", label: "Class 5 (16,001-19,500 lbs)" },
  { value: "class_7", label: "Class 7 (26,001-33,000 lbs)" },
  { value: "class_8", label: "Class 8 (33,001+ lbs)" },
];
